import { getSessionToken } from '@a6tr/domains/authentication/session';
import type { Interceptor } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';

import { config } from '@/config/config';

const addSessionInterceptor: Interceptor = (next) => async (req) => {
	const token = getSessionToken();
	if (token) {
		req.header.set('Authorization', `Bearer ${token}`);
	}
	return next(req);
};

// The back-office is French only; the API localizes its messages from this header.
const addLanguageHeaderInterceptor: Interceptor = (next) => async (req) => {
	req.header.set('Accept-Language', 'fr');
	return next(req);
};

export const getTransport = () =>
	createConnectTransport({
		baseUrl: config.apiUrl,
		interceptors: [addSessionInterceptor, addLanguageHeaderInterceptor],
		fetch: (url, options) => fetch(url, { ...options, credentials: 'include' }),
	});
